import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface ModalProps {
    children: React.ReactNode;
    title: string;
    footer: React.ReactNode;
    show: boolean;
    onHide: () => void;
}

const ModalEL: React.FC<ModalProps> = ({children, title, footer, show, onHide}) => {
    return (
        <Dialog
            open={show}
            onClose={onHide}
            maxWidth="lg"
            fullWidth
            aria-labelledby="modal-title"
        >
            <DialogTitle id="modal-title">
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onHide}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                {footer}
            </DialogActions>
        </Dialog>
    );
}

export default ModalEL;
